import styles from './index.module.sass';
import envolope from 'images/new_bg.svg';

const Envolope = ({ onLoad = () => {} }) => {
  return (
    <div className={styles.envolope}>
      <img onLoad={onLoad} src={envolope} alt="envolope" />
    </div>
  );
};

export default Envolope;
